import React from 'react';
import {connect} from 'react-redux';
import {Field, InjectedFormProps, reduxForm} from 'redux-form'
import {Button, Card, CardBody, Col, FormGroup} from 'reactstrap';
import ReduxFormInput from "@Utils/ReduxFormInput";
import validate, { FolderParams } from './validate';
import {AppState} from "@Redux/store";
import {FolderView} from "@Selectors/builder/myArmyList/common/ArmyListView";
import ReduxFormSelect from "@Utils/ReduxFormSelect";
import ReduxFormCheck from "@Utils/ReduxFormCheck";
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';

interface Props {
  folders: Array<FolderView>
  folder: FolderView
  cancel: () => void,
  onSubmit: (values: any) => void,
  canSubmit: boolean,
}

const Form: React.FC<Props & InjectedFormProps<FolderParams, Props>> = ({
                                                                          folders,
                                                                          cancel,
                                                                          handleSubmit,
                                                                          canSubmit
                                                                        }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Col sm="12">
        <Card className="card-border">
          <CardBody>
            <h2 className="text-center"><FormattedMessage {...defaultMessages.folderEditTitle} /></h2>

            <FormGroup row={true}>
              <Col xs="12" md={12} lg="4">
                <Field
                  name="name"
                  type="text"
                  component={ReduxFormInput}
                  label={defaultMessages.folderFormNameTitle}
                  placeHolder={defaultMessages.folderFormNamePlaceholder}
                />
              </Col>
            </FormGroup>

            <FormGroup row={true}>
              <Col xs="12" md={6} lg={4}>
                <Field
                  name="parentId"
                  datas={folders}
                  noValue={true}
                  component={ReduxFormSelect}
                  label={defaultMessages.folderFormParentTitle}
                  placeHolder={defaultMessages.folderFormParentPlaceholder}
                />
              </Col>
              <Col xs="12" md={6} lg={4}>
                <Field
                  name="isShare"
                  type="checkbox"
                  component={ReduxFormCheck}
                  label={defaultMessages.folderFormIsShareTitle}
                />
              </Col>
            </FormGroup>

          </CardBody>
          <div className="mb-2 text-center">
            <Button disabled={!canSubmit} onClick={() => cancel()} color="age" type="button"><FormattedMessage {...defaultMessages.formCancel} /></Button>
            <Button disabled={!canSubmit} color="age" type="submit"><FormattedMessage {...defaultMessages.formSave} /></Button>
          </div>
        </Card>
      </Col>
    </form>
  );
}

const EditFolderForm = reduxForm<FolderParams, Props>({
  form: 'edit_folder',
  validate,
})(Form);

const mapStateToProps = (state: AppState, props: Props) => {
  return {
    onSubmit: props.onSubmit,
    initialValues: {
      name: props.folder.name,
      parentId: props.folder.parentId,
      isShare: props.folder.isShare,
    },
  }
}

export default connect(mapStateToProps)(EditFolderForm);
